var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1508 17.0247L9.52578 13.3997C9.44245 13.3164 9.38411 13.233 9.35078 13.1497C9.31745 13.0664 9.30078 12.9747 9.30078 12.8747C9.30078 12.7747 9.31745 12.683 9.35078 12.5997C9.38411 12.5164 9.44245 12.433 9.52578 12.3497L13.1508 8.72471C13.2008 8.67471 13.2549 8.63721 13.3133 8.61221C13.3716 8.58721 13.4341 8.57471 13.5008 8.57471C13.6341 8.57471 13.7508 8.62054 13.8508 8.71221C13.9508 8.80387 14.0008 8.92471 14.0008 9.07471V16.6747C14.0008 16.8247 13.9508 16.9455 13.8508 17.0372C13.7508 17.1289 13.6341 17.1747 13.5008 17.1747C13.4674 17.1747 13.3508 17.1247 13.1508 17.0247Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRounded);
export default __webpack_public_path__ + "static/media/arrow-left-rounded.ef92bce1cb21e2c40025eaa43fe53743.svg";
export { ForwardRef as ReactComponent };